import {
  PAGE_AUDIT_LOG,
  PAGE_DASHBOARD,
  PAGE_EDIT_GROUP,
  PAGE_EDIT_USER,
  PAGE_GROUPS,
  PAGE_MAIN_SETTINGS,
  PAGE_NEW_GROUP,
  PAGE_NEW_USER,
  PAGE_NOTIFICATIONS,
  PAGE_USERS,
  PAGE_VIEW_USER
} from "../../pages/Core/routes";
import { PAGE_DOM_SETTINGS } from "../../pages/Dom/routes";
import { PAGE_IOR_SETTINGS } from "../../pages/Ior/routes";
import { PAGE_ORGANIZATION_SETTINGS } from "../../pages/Organization/routes";
import { PAGE_QAM_SETTINGS } from "../../pages/Qam/routes";
import { PAGE_RSM_SETTINGS } from "../../pages/Rsm/routes";
import { PAGE_TRG_SETTINGS } from "../../pages/Trg/routes";
import {
  PERMISSION_MANAGE_CORE_SETTINGS,
  PERMISSION_MANAGE_DOM_SETTINGS,
  PERMISSION_MANAGE_IOR_SETTINGS,
  PERMISSION_MANAGE_ORG_SETTINGS,
  PERMISSION_MANAGE_QAM_SETTINGS,
  PERMISSION_MANAGE_RSM_SETTINGS,
  PERMISSION_MANAGE_TRG_SETTINGS,
  PERMISSION_VIEW_CORE_AUDIT_LOG,
  PERMISSION_VIEW_CORE_GROUPS,
  PERMISSION_VIEW_CORE_NOTIFICATIONS,
  PERMISSION_VIEW_CORE_USERS,
  PERMISSION_VIEW_DOM_SETTINGS,
  PERMISSION_VIEW_IOR_SETTINGS,
  PERMISSION_VIEW_ORG_SETTINGS,
  PERMISSION_VIEW_QAM_SETTINGS,
  PERMISSION_VIEW_RSM_SETTINGS,
  PERMISSION_VIEW_TRG_SETTINGS
} from "./permissions/permissions";

/** Dashboard — always visible to all authenticated users; no permission gate required. */
export const NAV_CORE_DASHBOARD = {
  key: "dashboard",
  name: "container.sidebar.dashboard",
  path: PAGE_DASHBOARD,
  iconClassName: "ti-dashboard"
};

/** Users & Groups — user accounts, permission groups, and role assignments. */
export const NAV_USERS_GROUPS = {
  key: "users_groups",
  name: "container.sidebar.users_and_groups",
  iconClassName: "ti-lock",
  gates: [PERMISSION_VIEW_CORE_USERS, PERMISSION_VIEW_CORE_GROUPS],
  submenu: [
    {
      key: "users_groups.users",
      name: "container.sidebar.users",
      path: PAGE_USERS,
      gates: PERMISSION_VIEW_CORE_USERS,
      activeRoutes: [PAGE_NEW_USER, PAGE_EDIT_USER, PAGE_VIEW_USER]
    },
    {
      key: "users_groups.groups",
      name: "container.sidebar.groups",
      path: PAGE_GROUPS,
      gates: PERMISSION_VIEW_CORE_GROUPS,
      activeRoutes: [PAGE_NEW_GROUP, PAGE_EDIT_GROUP]
    }
  ]
};

/**
 * Settings — aggregates module-specific settings sub-pages under one sidebar section.
 * The gates list includes all module settings permissions so the item is visible to any
 * user who can access at least one module's settings page.
 */
export const NAV_SETTINGS = {
  key: "settings",
  name: "container.sidebar.settings",
  iconClassName: "ti-settings",
  gates: [
    PERMISSION_MANAGE_CORE_SETTINGS,
    PERMISSION_MANAGE_QAM_SETTINGS,
    PERMISSION_VIEW_QAM_SETTINGS,
    PERMISSION_MANAGE_ORG_SETTINGS,
    PERMISSION_VIEW_ORG_SETTINGS,
    PERMISSION_MANAGE_TRG_SETTINGS,
    PERMISSION_VIEW_TRG_SETTINGS,
    PERMISSION_VIEW_RSM_SETTINGS,
    PERMISSION_MANAGE_RSM_SETTINGS,
    PERMISSION_MANAGE_IOR_SETTINGS,
    PERMISSION_VIEW_IOR_SETTINGS,
    PERMISSION_VIEW_DOM_SETTINGS
  ],
  submenu: [
    {
      key: "settings.main_settings",
      name: "container.sidebar.main_settings",
      path: PAGE_MAIN_SETTINGS,
      gates: PERMISSION_MANAGE_CORE_SETTINGS
    },
    {
      key: "settings.dom_settings",
      name: "container.sidebar.dom_settings",
      path: PAGE_DOM_SETTINGS,
      gates: [PERMISSION_MANAGE_DOM_SETTINGS, PERMISSION_VIEW_DOM_SETTINGS]
    },
    {
      key: "settings.qam_settings",
      name: "container.sidebar.qam_settings",
      path: PAGE_QAM_SETTINGS,
      gates: [PERMISSION_MANAGE_QAM_SETTINGS, PERMISSION_VIEW_QAM_SETTINGS]
    },
    {
      key: "settings.org_settings",
      name: "container.sidebar.org_settings",
      path: PAGE_ORGANIZATION_SETTINGS,
      gates: [PERMISSION_MANAGE_ORG_SETTINGS, PERMISSION_VIEW_ORG_SETTINGS]
    },
    {
      key: "settings.trg_settings",
      name: "container.sidebar.trg_settings",
      path: PAGE_TRG_SETTINGS,
      gates: [PERMISSION_MANAGE_TRG_SETTINGS, PERMISSION_VIEW_TRG_SETTINGS]
    },
    {
      key: "settings.rsm_settings",
      name: "container.sidebar.rsm_settings",
      path: PAGE_RSM_SETTINGS,
      gates: PERMISSION_VIEW_RSM_SETTINGS
    },
    {
      key: "settings.ior_settings",
      name: "container.sidebar.ior_settings",
      path: PAGE_IOR_SETTINGS,
      gates: [PERMISSION_MANAGE_IOR_SETTINGS, PERMISSION_VIEW_IOR_SETTINGS]
    }
  ]
};

/** In-app notification centre — real-time alerts for events the user is subscribed to. */
export const NAV_NOTIFICATIONS = {
  key: "notifications",
  name: "container.sidebar.notifications",
  path: PAGE_NOTIFICATIONS,
  iconClassName: "ti-bell",
  gates: PERMISSION_VIEW_CORE_NOTIFICATIONS
};

/** Audit log — chronological record of all system actions performed by all users. */
export const NAV_AUDIT_LOGS = {
  key: "audit_log",
  name: "container.sidebar.audit_log",
  path: PAGE_AUDIT_LOG,
  iconClassName: "ti-book",
  gates: PERMISSION_VIEW_CORE_AUDIT_LOG
};
